<template>
    <div class="soldout-subscribe">
        <div class="soldout-subscribe__prefix" :class="{ 'soldout-subscribe__prefix--taller': tallerPrefix }">
            {{ $t('ProductDetails.productSelect.soldOut.prefix') }}
        </div>

        <SubscribeToProduct :product-details="productDetails">
            <template #header>{{ $t('ProductDetails.productSelect.soldOut.header') }}</template>

            <template #description>
                <p>{{ $t('ProductDetails.productSelect.soldOut.text') }}</p></template
            >

            <template #append>
                <translate path="ProductExpiredSubscribe.dataProtection" tag="small" class="d-block">
                    <template #link>
                        <nuxt-link
                            :to="{ name: 'category', params: { category: 'datenschutz' } }"
                            target="_blank"
                            @click.native="$event.stopImmediatePropagation()"
                        >
                            {{ $t('DataProtection.link').trim() }}
                        </nuxt-link>
                    </template>
                </translate>
            </template>

            <template #subscribed>
                <p>
                    {{ $t('ProductDetails.productSelect.soldOut.subscribedText', { hotel: productDetails.hotel }) }}
                </p>
            </template>
        </SubscribeToProduct>
    </div>
</template>

<script>
import SubscribeToProduct from '@/components/product/SubscribeToProduct.vue';

export default {
    name: 'SoldOutSubscribe',

    components: {
        SubscribeToProduct
    },

    props: {
        productDetails: {
            type: Object,
            required: true
        },

        tallerPrefix: Boolean
    }
};
</script>

<style lang="scss" scoped>
.soldout-subscribe {
    &__prefix {
        background-color: var(--soldout-color);
        color: var(--white);
        padding: 1rem;
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        font-size: 0.875rem;
        text-align: center; //better on mobile

        &--taller {
            margin-top: -1.3rem;
            padding-top: 2rem;
            margin-inline: -1px;
        }
    }
}
</style>
